import { Injectable } from "@angular/core";
import { map, retry, catchError } from "rxjs/operators";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { JwtHelperService } from "@auth0/angular-jwt";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class CoreService {
  constructor(
    private http: HttpClient,
    public jwtHelper: JwtHelperService,
    private router: Router
  ) {
    console.log('show loading');

  }

  get(url: string, header: HttpHeaders, params?: HttpParams): Observable<any> {
    let httpOptions = { headers: header, params: params };
    return this.http.get<any>(environment.BaaseUrl + url, httpOptions).pipe(
      retry(1),
      catchError((error) => {

        this.handleAuthError(error);
        return of(error);
      }) as any,
      map(res => res)
    );
  }

  getWithUrl(url: string): Observable<any> {
    return this.http.get<any>(url).pipe(
      retry(1),
      catchError((error) => {

        this.handleAuthError(error);
        return of(error);
      }) as any,
      map(res => res)
    );
  }

  post(
    url: string,
    data: any,
    header: HttpHeaders,
    params?: HttpParams
  ): Observable<any> {
    let httpOptions = { headers: header, params: params };
    return this.http
      .post<any>(environment.BaaseUrl + url, data, httpOptions)
      .pipe(
        retry(1),
        catchError((error) => {
          this.handleAuthError(error);
          return of(error);
        }) as any,
        map(res => res)
      );
  }

  put(url: string, data: any, header: HttpHeaders): Observable<any> {
    let httpOptions = { headers: header };
    return this.http
      .put<any>(environment.BaaseUrl + url, data, httpOptions)
      .pipe(
        retry(1),
        catchError((error) => {
          this.handleAuthError(error);
          return of(error);
        }) as any,
        map(res => res)
      );
  }

  delete(
    url: string,
    header: HttpHeaders,
    params?: HttpParams
  ): Observable<any> {
    let httpOptions = { headers: header, body: params };
    return this.http.delete<any>(environment.BaaseUrl + url, httpOptions).pipe(
      retry(1),
      catchError((error) => {
        this.handleAuthError(error);
        return of(error);
      }) as any,
      map(res => res)
    );
  }

  download(url: string) {
    window.location.href = url;
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401) {
      localStorage.clear();
      this.router.navigate(["login"]);
      return of(err.message);
    }
    throw err;
  }
}
